import { LinkProps, Link } from 'react-router-dom';

export function LinkComponent({ to, ...restProps }: LinkProps & { disabled?: boolean }) {
  if (restProps.disabled) {
    // eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/anchor-has-content, no-script-url
    return <a href='javascript:void(0)' {...restProps} />;
  }
  return <Link to={to} {...restProps} />;
}
